import React from 'react';
import logo from '../assets/NHL_logo.png';
import avatar from '../assets/avatar.png';
import NotificationDropdown from '../components/NotificationDropdown';

function Submissions() {
  return (
<div>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Admin Panel - Student Project Management</title>
        <div className="min-h-screen flex">
          <aside className="w-64 bg-white border-r border-gray-200 fixed h-full">
            <div className="px-6 py-4 border-b border-gray-200">
              <img src={logo} alt="Logo" className="h-18" />
            </div>
            <nav className="mt-6 px-3">
              <a href="/adminpanel" className="flex items-center px-3 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-gray-50 mb-1">
                <i className="fas fa-home w-5 h-5 mr-2" />
                Dashboard
              </a>
              <a href="/courses" className="flex items-center px-3 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-gray-50 mb-1">
                <i className="fas fa-book w-5 h-5 mr-2" />
                Courses
              </a>
              <a href="#" className="flex items-center px-3 py-2 text-sm font-medium rounded-md bg-black text-white mb-1"><i className="fas fa-file-alt w-5 h-5 mr-2" /> Submissions </a>
              <a href="#" className="flex items-center px-3 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-gray-50">
                <i className="fas fa-users w-5 h-5 mr-2" />
                Users
              </a>
            </nav>
          </aside>
          <div className="flex-1 ml-64">
            <header className="bg-white shadow-sm">
              <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                  <h1 className="text-xl font-semibold text-gray-900 flex items-center">Submissions</h1>
                  <div className="flex items-center">
                  <NotificationDropdown />
                    <div className="ml-4 flex items-center">
                      <img className="h-8 w-8 rounded-full" src={avatar} alt="User" />
                      <span className="ml-2 text-sm font-medium text-gray-700">Admin User</span>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            <main className="max-w-8xl mx-auto py-6 sm:px-6 lg:px-8">
            <div className="bg-white shadow rounded-lg">
              <div className="px-6 py-6">
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-lg font-medium text-gray-900">Recent Submissions</h2>
                </div>
                <div className="space-y-4">
                  {/* Submission 1 */}
                  <div className="border rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="text-lg font-medium text-gray-900">Web Development Project</h3>
                        <p className="text-sm text-gray-500">John Smith - Web Development Fundamentals</p>
                        <p className="text-sm text-gray-500 mt-1">Submitted: Jan 20, 2024</p>
                      </div>
                      <span className="px-3 py-1 text-sm font-medium rounded-full bg-yellow-100 text-yellow-800">Pending Review</span>
                    </div>
                  </div>
                  {/* Submission 2 */}
                  <div className="border rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="text-lg font-medium text-gray-900">Database Design Project</h3>
                        <p className="text-sm text-gray-500">Emily Johnson - Database Design</p>
                        <p className="text-sm text-gray-500 mt-1">Submitted: Jan 19, 2024</p>
                      </div>
                      <span className="px-3 py-1 text-sm font-medium rounded-full bg-green-100 text-green-800">Reviewed</span>
                    </div>
                  </div>
                  {/* Submission 3 */}
                  <div className="border rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="text-lg font-medium text-gray-900">Mobile App Prototype</h3>
                        <p className="text-sm text-gray-500">Michael Brown - Mobile App Development</p>
                        <p className="text-sm text-gray-500 mt-1">Submitted: Jan 18, 2024</p>
                      </div>
                      <span className="px-3 py-1 text-sm font-medium rounded-full bg-green-100 text-green-800">Reviewed</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
            </div>
        </div>
        <footer className="bg-white border-t border-gray-200 fixed bottom-0 w-full">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="py-4 text-center text-sm text-gray-500">
              <p>© 2024 NHL Stenden. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </div>
  );
}

export default Submissions;
